export const BASE_URL = "https://app.zenpath-admin.com:5000";

export const DELETE_ACCOUNT_API = BASE_URL + "/delete_id";
